<template>
    <div>
      <b-progress :max="max">
        <b-progress-bar :value=valueOperative v-b-popover.hover.top="messageOperative"></b-progress-bar>
        <b-progress-bar :value="valueAdministrative" variant="danger" v-b-popover.hover.top="messageAdministrative"></b-progress-bar>
      </b-progress>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ProgressBar',
    data() {
      return {
        
        max: 100
      }
    },
    props:{
      valueOperative:{
      default: 0,
      type: Number
    },
      valueAdministrative:{
      default: 0,
      type: Number
    },
      messageAdministrative:{
        default: '',
        type: String
      },
      messageOperative:{
        default: '',
        type: String
      }
  },
}
  </script>
  
  
  <style scoped>
    .form-group{
      margin-bottom: 0;
    }
    .progress{
      background-color: #FF9900;
      height: 0.8rem;
      cursor: pointer;
    }
    .progress-bar{
      border-radius: 6px;
      background-color: #5D5FEF;
      cursor: pointer;
    }
    .progress-bar.bg-danger{
      background-color: #FF9900 !important;
      border-bottom-right-radius: 6px;
      border-top-right-radius: 6px;
      cursor: pointer;
    }

  </style>